const urls = {
      addComments: 'react/addmycomment',
      addContribution: 'react/addmycontribution',
      adminEditQuestion: 'react/editquestions/',
      getRateLimiter: 'react/ratelimiters',
      addquestionreport: 'react/addquestionreport',
      searchQuestionByKey: 'react/searchquestionbykey',
      mistakes: 'react/mistakes',
      getSqlDump: 'angular/mysqldump',
      deleteMistake: 'react/deletemistake/',
      postDeleteMistake: 'react/postdeletemistake'
  };

export default urls;